import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import { c as o } from "./index-8b07dec9.js";
import F from "react";
import r, { css as n } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Y } from "./getMetrics-953aa4f8.js";
import "./es.symbol.description-6025a604.js";
import { useTheme as Z, ThemeName as tt } from "@ucl/shared-component-foundations";
import { a as G } from "./index-5d0f31c6.js";
import { f as et, e as it } from "./index-f5b44da3.js";
import { useAccessibilityProps as at } from "./accessibility.js";
import { jsxs as d, jsx as i } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.keys-9d66766f.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.array.some-0c761b6d.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-json-b76d522e.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./aria.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./useWindowSize.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./button.js";
import "./combineRefs-c9ad2c39.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var rt = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__ListWrapper",
  componentId: "sc-7kgoaa-0"
})(["&.ListWrapper{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.ListWrapper);
}), nt = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__ListContent",
  componentId: "sc-7kgoaa-1"
})(["&.ListContent{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.ListContent);
}), ot = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__LeadingElementWrapper",
  componentId: "sc-7kgoaa-2"
})(["&.LeadingElementWrapper{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.LeadingElementWrapper);
}), pt = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__TagsAndContentWrapper",
  componentId: "sc-7kgoaa-3"
})(["&.TagsAndContentWrapper{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.TagsAndContent);
}), H = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__SecondaryContent",
  componentId: "sc-7kgoaa-4"
})(["&.SecondaryContent{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.SecondaryContent);
}), K = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__SecondaryIconWrapper",
  componentId: "sc-7kgoaa-5"
})(["&.SecondaryIconWrapper{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.SecondaryIconWrapper);
}), mt = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__PrimaryContent",
  componentId: "sc-7kgoaa-6"
})(["&.PrimaryContent{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.PrimaryContent);
}), st = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__Rule",
  componentId: "sc-7kgoaa-7"
})(["&.Rule{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.Rule);
}), A = /* @__PURE__ */ r.div.withConfig({
  displayName: "dataListItem__TrailingElementWrapper",
  componentId: "sc-7kgoaa-8"
})(["&.TrailingElementWrapper{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.TrailingElementWrapper);
}), M = function(t) {
  var g = t.label, w = t.description, I = t.leadingElement, u = t.leadingElementSize, W = u === void 0 ? "l" : u, s = t.trailingElement, v = t.trailingElementAlignment, l = v === void 0 ? "center" : v, L = t.secondaryIcon, R = t.eyebrowProps, N = t.tagProps, _ = t.isStatic, D = _ === void 0 ? !1 : _, p = t._selectHandler, P = t._type, h = P === void 0 ? "action" : P, y = t._static, c = y === void 0 ? !1 : y, E = t._hasRule, f = E === void 0 ? !1 : E, a = t.className, b = t.isActive, T = b === void 0 ? !1 : b, O = t.accessibilityOptions, B = O === void 0 ? {} : O, x = t.value, S = c || D, $ = N || {}, J = $.tagGroupProps, C = $.tagsData, j = $._renderTags, z = R || {}, Q = z.eyebrowText, q = z.eyebrowIcon, U = Z(), V = U.themeName, X = at("listitem", Object.assign({}, B));
  return /* @__PURE__ */ d("li", {
    children: [/* @__PURE__ */ i(rt, Object.assign({
      tabIndex: S ? void 0 : 0,
      onKeyDown: function(m) {
        (m.code === "Space" || m.code === "Enter") && p && p(m, g, x);
      },
      className: o(["ListWrapper", a, "ListWrapper--" + h, {
        "ListWrapper--active": T
      }, {
        "ListWrapper--static": S
      }, {
        "ListWrapper--rule": f
      }, {
        "ListWrapper--event": !!p
      }]),
      onClick: function(m) {
        return p && p(m, g, x);
      }
    }, X, {
      children: /* @__PURE__ */ d("div", {
        children: [I && /* @__PURE__ */ i(ot, {
          className: o(["LeadingElementWrapper", a, "LeadingElementWrapper--" + W]),
          children: I
        }), /* @__PURE__ */ d(pt, {
          tabIndex: -1,
          className: o(["TagsAndContentWrapper", a]),
          children: [j ? j(C) : C && (C == null ? void 0 : C.length) > 0 && /* @__PURE__ */ i(et, Object.assign({
            overflow: !0,
            visibleTags: 1
          }, J, {
            children: C.map(function(k, m) {
              return /* @__PURE__ */ i(it, Object.assign({}, k), m);
            })
          })), /* @__PURE__ */ d(H, {
            className: "SecondaryContent",
            children: [q && /* @__PURE__ */ i(K, {
              className: "SecondaryIconWrapper",
              children: q
            }), Q]
          }), /* @__PURE__ */ d(nt, {
            tabIndex: -1,
            className: o([a, "ListContent"]),
            children: [/* @__PURE__ */ i(mt, {
              className: "PrimaryContent",
              children: /* @__PURE__ */ i("div", {
                className: "title",
                children: g
              })
            }), /* @__PURE__ */ d(H, {
              className: "SecondaryContent",
              children: [L && /* @__PURE__ */ i(K, {
                className: "SecondaryIconWrapper",
                children: L
              }), w]
            })]
          })]
        }), s ? s !== "none" ? /* @__PURE__ */ i(A, {
          className: o(["TrailingElementWrapper", a, "TrailingElementWrapper--" + l]),
          children: s
        }) : null : !S && V === tt.FORD_PRO ? /* @__PURE__ */ i(A, {
          className: o(["TrailingElementWrapper", a, "TrailingElementWrapper--" + l, {
            "TrailingElementWrapper--padding": !0
          }]),
          children: /* @__PURE__ */ i(G, {
            icon: "caretRightFilled",
            size: "m"
          })
        }) : /* @__PURE__ */ i(A, {
          className: o(["TrailingElementWrapper", a, "TrailingElementWrapper--" + l]),
          children: /* @__PURE__ */ i(G, {
            icon: "caretRight",
            size: "s"
          })
        })]
      })
    })), f && h !== "boxed" && /* @__PURE__ */ i(st, {
      className: o(["Rule", a, "Rule--" + h, {
        "Rule--active": T
      }, {
        "Rule--static": S
      }])
    })]
  });
}, lt = /* @__PURE__ */ r.ul.withConfig({
  displayName: "dataList__StyledDataList",
  componentId: "sc-1y4siwf-0"
})(["&.DataList{", ";}"], function(e) {
  var t = e.theme.components.dataList;
  return n(t.DataList);
}), ct = function(t) {
  var g = t.children, w = t.uniqueIdentifier, I = t.ariaLabel, u = t.onChange, W = u === void 0 ? null : u, s = t.type, v = s === void 0 ? "default" : s, l = t.isStatic, L = l === void 0 ? !1 : l, R = t.className, N = t.hasRule, _ = N === void 0 ? !1 : N, D = Y({
    label: "DataList"
  }), p = function(h) {
    var y = !0;
    return F.Children.map(h, function(c) {
      if ((c == null ? void 0 : c.type) === M) {
        var E = c.props, f = !1;
        return E.isActive && y && (f = !0, y = !1), /* @__PURE__ */ F.cloneElement(c, Object.assign({}, {
          _type: v,
          _selectHandler: !L && W ? function(a, b, T) {
            return W(a, b, T);
          } : null,
          isActive: f,
          _hasRule: _,
          _static: L
        }));
      }
      return null;
    });
  };
  return /* @__PURE__ */ i(lt, Object.assign({
    "aria-label": I,
    className: o([R, "DataList", "DataList--" + v]),
    id: w
  }, D, {
    children: p(g)
  }));
};
ct.Item = M;
export {
  ct as DataList
};
